import React from 'react'
import { Calendar } from 'primereact/calendar'

const TimeFilterTemplate = ({ options }) => {
    return (
        <Calendar
            value={options.value}
            onChange={(e) => options.filterCallback(e.value, options.index)}
            showTime={true}
            timeOnly
            hourFormat="24"/>
    )
}

export default TimeFilterTemplate
